import { Col, Container, Row } from "react-bootstrap";
import React from "react";
import styles from "./style.module.scss";
import { parseHtml } from "../../../utils/common";

const Enterprices = ({ data }) => {
	return (
		<section className={`${styles["enterprices-section"]} bg-one home-padding-new`}>
			<Container className={styles['container']}>
				<Row className="justify-content-center">
					<Col lg={10}>
						<div className={styles["enterprices-content"]}>
							<h2 className="text-black">{data.title}</h2>
							<p className="font-medium text-light-black">{data.short_title}</p>
						</div>
					</Col>
					{data?.statistics &&
						data?.statistics.map((val, i) => {
							return (
								<Col lg={4} sm={6} xs={12} key={i}>
									<div
										className={
											i < 4
												? styles["clientbox-content"]
												: `${styles["clientbox-content"]} ${styles["line-green"]}`
										}
									>
										<h3 className="h2 text-black">{val.numbers}</h3>
										<p className="text-light-black font-medium">{val.title}</p>
										<p className="text-light-black font-medium">{parseHtml(val.description)}</p>
										<span className="bg-primary-gradient"></span>

									</div>
								</Col>
							);
						})}
				</Row>
			</Container>
		</section>
	);
};

export default Enterprices;
